import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Modal, ModalHeader, ModalBody, ModalFooter, Toast, ToastHeader, ToastBody } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserMinus, faUsersLine, faMagnifyingGlass, faFloppyDisk, faPlus, faUserPlus, faSpinner } from '@fortawesome/free-solid-svg-icons';
import useApiFetch from '../../ApiFetch';
import moment from 'moment';
import { NumericFormat, PatternFormat } from 'react-number-format';

export default function EventGuests(props) {
    const { event, registrationId, done, updatedGuests } = props;
    const apiFetch = useApiFetch();

    const [students, setStudents] = useState([]);

    const [newGuest, setNewGuest] = useState({
        eventId: event?.id ?? null,
        registrationId: registrationId,
        email: null,
        firstName: null,
        lastName: null,
        company: null,
        phone: null
    });
    const [guests, setGuests] = useState([]);
    const [addingGuest, setAddingGuest] = useState(false);

    const [findStudentId, setFindStudentId] = useState(null);
    const [findDOB, setFindDOB] = useState(null);
    const [findingStudent, setFindingStudent] = useState(false);


    const [modalAdd, setModalAdd] = useState(false);

    const toggleModalAdd = () => setModalAdd(!modalAdd);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {

        //get the profile data
        //    await apiFetch.get('/api/profile/students')
        //        .then(resp => {
        //            setStudents(resp.data);
        //            console.log(resp.data);
        //        });
    };
    const addGuest = async (e) => {
        e.preventDefault();
        e.stopPropagation();
        setAddingGuest(true);

        setGuests([...guests, newGuest]);
        setNewGuest({
            eventId: event?.id ?? null,
            registrationId: registrationId,
            email: null,
            firstName: null,
            lastName: null,
            company: null,
            phone: null
        });
        setAddingGuest(false);
        if (updatedGuests) {
            updatedGuests([...guests, newGuest]);
        }


        //await apiFetch.post('/api/event/guest/', newGuest)
        //    .then(resp => {
        //        if (resp.data) {
        //            setGuests([...guests, resp.data ])

        //            setNewGuest({
        //                eventId: event?.id ?? null,
        //                registrationId: registrationId,
        //                email: null,
        //                firstName: null,
        //                lastName: null,
        //                company: null,
        //                phone: null
        //            });
        //        }
        //        else {
        //        }
        //        setAddingGuest(false);
        //    })
        //    .catch(err => {
        //        console.error(err);
        //        setAddingGuest(false);
        //    //    if (err.response && err.response && err.response.data === "Invalid Code")
        //    //        setInvalidCode(true);
        //    });

    };
    const removeGuest = async (i) => {
        var theGuest = guests?.[i];
        if (theGuest) {
            //await apiFetch.delete('/api/event/guest/' + encodeURIComponent(theGuest.id))
            //    .then(resp => {
            setGuests(prevGuests => prevGuests.filter((_, index) => index !== i));
            if (updatedGuests) {
                updatedGuests([...guests.filter((_, index) => index !== i)]);
            }
        //        })
        //        .catch(err => {
        //            console.error(err);
        //            //    if (err.response && err.response && err.response.data === "Invalid Code")
        //            //        setInvalidCode(true);
        //        });
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); // Prevents form submission or newline
            if (newGuest && newGuest.firstName && newGuest.lastName && (!event?.maxGuestsAllowed || event?.maxGuestsAllowed > guests?.length))
                addGuest(e);
        }
    };
    const doneAddingGuests = (e) => {
        if (done)
            done(guests);

        toggleModalAdd();
    };


    return (
        <>
            <div className="col">
            {/*    <Link className="link link-primary " onClick={toggleModalAdd} >*/}
            {/*        Add Guests*/}
            {/*    </Link>*/}
                {guests && guests.length > 0 ?
                    <Link className="link-success fs-5 fw-semibold text-decoration-none" onClick={toggleModalAdd}>Guests Included: <b>{guests.length}</b></Link>
                    :
                    <Link className="link-primary fs-5 fw-semibold text-decoration-none" onClick={toggleModalAdd}>Add Guests Here</Link>
                }
            </div>
            <Modal isOpen={modalAdd} toggle={toggleModalAdd} size="md" fade>
                <ModalHeader toggle={toggleModalAdd}>
                    <FontAwesomeIcon icon={faUsersLine} className="pe-2" />Add Guests
                </ModalHeader>
                <ModalBody className="">
                    {/*<h4 className="mb-4"></h4>*/}
                    <p className="">Guests will have their own passes.  Please add guests by providing their info below.</p>
                    <ol className="list-group mb-4">
                        <li className="list-group-item justify-content-between align-items-start">
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label htmlFor="firstName" className="form-label">First Name *</label>
                                    <input type="text" onKeyDown={(e) => handleKeyDown(e)} className="form-control" placeholder="" name="firstName" onChange={(e) => setNewGuest({ ...newGuest, [e.target.name]: e.target.value })} value={newGuest?.firstName ?? ''} />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="lastName" className="form-label">Last Name *</label>
                                    <input type="text" onKeyDown={(e) => handleKeyDown(e)} className="form-control" placeholder="" name="lastName" onChange={(e) => setNewGuest({ ...newGuest, [e.target.name]: e.target.value })} value={newGuest?.lastName ?? ''} />
                                </div>
                                <div className="col-12">
                                    <label htmlFor="Company" className="form-label">Company</label>
                                    <input type="text" onKeyDown={(e) => handleKeyDown(e)} className="form-control" placeholder="" name="company" onChange={(e) => setNewGuest({ ...newGuest, [e.target.name]: e.target.value })} value={newGuest?.company ?? ''} />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="email" className="form-label">Email</label>
                                    <input type="email" name="email" value={newGuest?.email ?? ''} onKeyDown={(e) => handleKeyDown(e)} className="form-control" placeholder="" onChange={(e) => setNewGuest({ ...newGuest, [e.target.name]: e.target.value })} />
                                </div>
                                <div className="col-md-6">
                                    <label htmlFor="phone" className="form-label">Phone</label>
                                    <PatternFormat name="phone" placeholder="Phone" onValueChange={(values, sourceInfo) => {
                                        if (sourceInfo.source !== 'event') {
                                            return;
                                        }
                                        setNewGuest({ ...newGuest, [sourceInfo.event.target.name]: values.value })
                                    }} className="form-control" id="phone" format="+1 (###) ###-####" value={newGuest?.phone ?? ''} valueIsNumericString={true} allowEmptyFormatting mask="_" />
                                </div>
                                <div className="col-md-12 text-end">
                                    <button type="submit" className="btn btn-primary w-auto ms-auto" disabled={!(newGuest && newGuest.firstName && newGuest.lastName && event?.supportsGuests && (!event?.maxGuestsAllowed || event?.maxGuestsAllowed > guests?.length))} onClick={addGuest}>
                                        <FontAwesomeIcon icon={addingGuest ? faSpinner : faUserPlus} spin={findingStudent} className="me-2" />
                                        Add Guest
                                    </button>
                                </div>
                            </div>
                        </li>
                    </ol>
                    {guests && guests.length > 0 &&
                        <>
                            {event?.supportsGuests && event?.maxGuestsAllowed && event?.maxGuestsAllowed <= guests.length &&
                                <small className="text-danger float-end">You are limited to <b>{event?.maxGuestsAllowed}</b> guests.</small>
                            }
                            <h6>My Guests</h6>
                            <ol className="list-group list-group-numbered mt-1">
                                {guests.map((g, i) =>
                                    <li key={i} className="list-group-item align-items-center">
                                        {g.firstName} {g.lastName} {g.company && <>- {g.company}</>} {g.email && <>({g.email})</>}
                                        <button type="submit" className="float-end badge btn btn-danger" disabled={false} onClick={() => removeGuest(i)}>
                                            <FontAwesomeIcon icon={findingStudent ? faSpinner : faUserMinus} spin={findingStudent} className="" />
                                        </button>
                                    </li>
                                )}
                            </ol>
                        </>
                    }
                </ModalBody>
                <ModalFooter>
                    {/*<Button color="secondary" onClick={toggleModalAdd}>*/}
                    {/*    Cancel*/}
                    {/*</Button>*/}
                    <Button color="primary" onClick={doneAddingGuests} disabled={false}>
                        Done Adding Guests
                    </Button>
                </ModalFooter>
            </Modal>

        </>
    );

}
